export default __webpack_public_path__ + "static/media/userdefault.921dff75.png";